import { DestroyRef, inject, signal } from '@angular/core';
import { StaffInboxStream } from './staff-inbox-stream';
import {
  StaffInboxService,
  type StaffConversationPreview,
  type StaffInboxSnapshot,
} from './staff-inbox.service';

const EMPTY: StaffInboxSnapshot = { unreadCount: 0, items: [] };
const REFRESH_MS = 30_000;

/**
 * Bandeja y preview de chat del header staff.
 * Llamar desde el contexto de inyección del layout.
 */
export function createHeaderInbox(): {
  items: ReturnType<typeof signal<StaffInboxSnapshot['items']>>;
  unreadCount: ReturnType<typeof signal<number>>;
  chatItems: ReturnType<typeof signal<StaffConversationPreview[]>>;
  markRead: (id: string) => void;
} {
  const service = inject(StaffInboxService);
  const stream = inject(StaffInboxStream);
  const destroyRef = inject(DestroyRef);
  const items = signal(EMPTY.items);
  const unreadCount = signal(EMPTY.unreadCount);
  const chatItems = signal<StaffConversationPreview[]>([]);
  let alive = true;

  const apply = (page: StaffInboxSnapshot) => {
    if (!alive) return;
    items.set(page.items);
    unreadCount.set(page.unreadCount);
  };

  const load = () => {
    service.list().subscribe((page) => apply(page));
    service.listConversations().subscribe((conversations) => {
      if (alive) chatItems.set(conversations);
    });
  };

  load();
  const timer = setInterval(load, REFRESH_MS);
  const stopStream = stream.listen((event) => {
    if (event === 'inbox' || event === 'chat') load();
  });
  destroyRef.onDestroy(() => {
    alive = false;
    clearInterval(timer);
    stopStream();
  });

  const markRead = (id: string) => {
    if (!id) return;
    service.markRead(id).subscribe({
      next: (page) => apply(page),
      error: () => load(),
    });
  };

  return { items, unreadCount, chatItems, markRead };
}
